import { mergeDeep } from './helpers';

let appsettings_default = {};
let appsettings = {};

// Get default config
try {
  const res = await fetch('/appsettings_default.json');
  if (res.ok) appsettings_default = await res.json();
} catch (e) {
  // Do nothing
}

// Get config from appsettings
try {
  const res = await fetch('/appsettings.json');
  if (res.ok) appsettings = await res.json();
} catch (e) {
  // Do nothing
}

// Overwrite default config with config from appsettings, if present.
const config = mergeDeep(appsettings_default, appsettings);

export default config;
